import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useGetRequest from "./useGetRequest";

const useNetworkUsers = () => {
    const  business = useSelector((state) => state.business);
    const [fetchSuppliers, supps, suppliersLoading] = useGetRequest();
    const [addNetworkModal, setAddNetworkModal] = useState(false);
    const [searchString, setSearchString] = useState("");
    const nameToUse = (supplier) =>
        supplier?.business?._id === business?._id
            ? supplier?.businessName?.toLowerCase()
            : supplier?.business?.name.toLowerCase();

    const suppliers = supps
        ?.filter((supplier) => nameToUse(supplier)?.includes(searchString.toLowerCase()))
        ?.sort((a, b) => nameToUse(a)?.localeCompare(nameToUse(b)));

    const alphabets = [
        ...new Set(suppliers?.map((supp) => nameToUse(supp)?.charAt(0)?.toUpperCase())),
    ];

    const handleFetchSuppliers = (businessId) => {
        fetchSuppliers("/v1/flex/users", {
            headers: { "x-business-id": businessId },
        });
    };

    useEffect(() => {
        !supps && handleFetchSuppliers(business?._id);

        setAddNetworkModal(false);
    }, [business?._id, supps]);

    return {
        suppliers,
        suppliersLoading,
        addNetworkModal,
        setAddNetworkModal,
        searchString,
        setSearchString,
        alphabets,
        business,
        nameToUse,
        fetchSuppliers,
    };
};

export default useNetworkUsers;
